import { TFormValue } from '../order-create-steps/add-lenses-step/add-lenses-step-form';
import { IFormItemValues } from '../order-create-page.models';

export const getIndexedFormValues = (products: TFormValue[]): IFormItemValues[] => {
  return [...products].map((product, index) => ({
    [`${index}`]: product,
  }));
};
